import { render, staticRenderFns } from "./PostTagEditorModal.vue?vue&type=template&id=d999a30c&"
import script from "./PostTagEditorModal.vue?vue&type=script&lang=js&"
export * from "./PostTagEditorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PostTagEditorModal.vue"
export default component.exports